/* ============================================================
   Questionnaire progress.

   A bar rather than 32 dots: at this count dots stop being scannable
   and start being noise, and they do not survive a 320px viewport.
   ============================================================ */

import { html } from '../shared/html.js';

export function Progress({ total, current, answered, domainName }) {
  const node = document.createElement('div');
  node.className = 'progress';
  update(node, { total, current, answered, domainName });
  return node;
}

export function update(node, { total, current, answered, domainName }) {
  const safeTotal = Math.max(1, total);
  const pct = Math.round((answered / safeTotal) * 100);

  node.innerHTML = html`
    <div class="progress-head">
      <span>${domainName || 'Diagnostic'}</span>
      <span class="num">Question ${Math.min(current + 1, safeTotal)} of ${safeTotal}</span>
    </div>
    <div
      class="progress-track"
      role="progressbar"
      aria-valuenow="${answered}"
      aria-valuemin="0"
      aria-valuemax="${safeTotal}"
      aria-label="Questions answered"
    >
      <div class="progress-fill" style="width: ${pct}%;"></div>
    </div>
  `;
  return node;
}
